import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { ContentIntelligenceProps } from '../src/ContentIntelligence.tsx';

export const ContentIntelligenceLoader: LoadableType<Omit<ContentIntelligenceProps, 'flags'>> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContentIntelligence" */ '../src/ContentIntelligence.tsx'
				)
			).ContentIntelligence,
	});
